document.addEventListener('DOMContentLoaded', () => {
  const $videoPlayers = document.querySelectorAll(
    '.js-video-player',
  )

  if ($videoPlayers.length === 0) return

  $videoPlayers.forEach(videoPlayer => {
    const playButton = videoPlayer.querySelector('.video-player__content .btn')
    const videoEl = videoPlayer.querySelector('nova-adaptive-video')
    playButton.addEventListener('click', (event) => {
      videoEl.play()
      videoEl._handlePlay()
    })
  })
})
